export default "__VITE_ASSET__okU4mTc6__"